import React, { useEffect, useState } from 'react'
import ImgPhone1 from '@/assets/images/phone-1.png'
import ImgPhone2 from '@/assets/images/phone-2.png'
import ImgPhone3 from '@/assets/images/phone-3.png'
import ImgPhone4 from '@/assets/images/phone-4.png'
import ImgPhone5 from '@/assets/images/phone-5.png'
import { Button } from '@nextui-org/react'
import { MdClose } from 'react-icons/md'
import { createPartFromUri, createUserContent, GoogleGenAI } from '@google/genai'
import GradientText from '@/components/GradientText/GradientText'
import NUIAlert from '@/components/Alert/Alert'
import { useParams } from 'react-router-dom'
import { enqueueSnackbar } from 'notistack'
import { webApiService } from '@/services'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { currencyFormat } from '@/utils/currencyFormat'
import { imagesToBase64Array } from '@/utils/imagesToBase64Array'

const defaultImages = [ImgPhone1, ImgPhone2, ImgPhone3, ImgPhone4, ImgPhone5, ImgPhone3]

const ai = new GoogleGenAI({ apiKey: import.meta.env.VITE_APIKEY_GEMINI })

const IAEvaluation = () => {
  const { ctx, saveCtx } = useTradeinContext()
  const [images, setImages] = useState<(File | null)[]>(Array(6).fill(null))
  const { id, slug } = useParams()
  const [data, setData] = useState<{ loading: boolean, result: any, cat: string, discount: number}>({ loading: false, result: null, cat: '', discount: 0 })

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const file = event.target.files?.[0]
    if (!file) return

    setImages((prevImages) => {
      const newImages = [...prevImages]
      newImages[index] = file
      return newImages
    })
  }

  const handleRemoveImage = (index: number) => {
    setImages((prevImages) => {
      const newImages = [...prevImages]
      newImages[index] = null
      return newImages
    })
  }

  async function consultaAI () {
    setData({ ...data, loading: true })
    let uploadedFiles
    try {
      uploadedFiles = await Promise.all(
        images.filter(img => img !== null).map(async (file) => {
          const response = await ai.files.upload({ file })
          return createPartFromUri(String(response.uri), String(response.mimeType))
        })
      )

      const response = await ai.models.generateContent({
        model: 'gemini-2.0-flash',
        contents: [
          createUserContent([
            `Necesito que a partir de estas imágenes correspondientes al mismo dispositivo me categorices el nivel de daño desde A a la D (siendo A el mejor y D el peor), 
            de equipos celulares como iPhone, Galaxy, etc.
            Validando que las 6 imagenes correspondan a cada una de las caras del dispositivo,
            Valida tambien que el orden de las imagenes sea el siguiente:
            Imagen 1: Frontal, Imagen 2: Trasera, Imagen 3: Lateral derecha, Imagen 4: Inferior, Imagen 5: Superior, Imagen 6: Lateral izquierda.
            Es necesario ademas que contestes la siguientes preguntas en base al analisis, 
            pregunta 1: ¿La carcasa (parte trasera y laterales del equipo) y las cámaras están en buenas condiciones (no presentan daños como quebraduras, trizaduras, abolladuras y/o piquetes)?
            las opciones de respuesta son: 8)En perfectas codiciones 9)Detalle de uso y rayones menores 10)Rayas mayores o mas profundas y 11)Trizadura o quebradura
            pregunta 2: ¿La carcasa (parte trasera y laterales del equipo) y las cámaras están en buenas condiciones (no presentan daños como quebraduras, trizaduras, abolladuras y/o piquetes)?
            las opciones de respuesta son: 8)En perfectas codiciones 9)Detalle de uso y rayones menores 10)Rayas mayores o mas profundas y 11)Trizadura o quebradura
            La alternativa de las respuestas en el json  en campos respuesa_1 y respuesa_2 respectivamente (solo el numero de la respuesta)
            La respues la necesito en un formato json como el siguiente ejemplo, donde se completen los comentarios por cada imagen, 
            y sin escribirme la palabra json en tu respuesta { "categoria": "A", "comentario_img_1": "", "comentario_img_2": "", "comentario_img_3": "", "comentario_img_4": "", "comentario_img_5": "", "comentario_img_6": "", respuesta_1: "", respuesta_2: "" } 
            y no me des más información que eso.`,
            ...uploadedFiles
          ])
        ]
      })

      const rawText = String(response.text).trim()

      // Intenta extraer solo el contenido entre llaves
      const jsonMatch = rawText.match(/{[\s\S]*}/)
      if (!jsonMatch) {
        throw new Error('No se encontró contenido JSON válido')
      }

      const parsedJson = JSON.parse(jsonMatch[0])

      const jsonString = String(response.text).replaceAll('`', '').replaceAll('json', '').replaceAll('\n', '')
      console.log('🚀 ~ consultaAI ~ letra:', parsedJson)

      const base64Images = await imagesToBase64Array(images)

      const payload = {
        metadata: { id_tradein: id, seller: slug, ...parsedJson },
        images: base64Images
      }
      console.log('👀 payload:', payload)

      webApiService.saveIAResult(payload)
        .then((response) => {
          console.log('🚀 ~ .then ~ response:', response)
          setData({ ...data, loading: false, result: JSON.parse(jsonString), cat: JSON.parse(jsonString).categoria })
          saveCtx({ ...ctx, reload: true, tradein: { ...ctx.tradein, grade: JSON.parse(jsonString).categoria } })
        }).catch((error) => {
          enqueueSnackbar(error.message, { variant: 'error' })
          setData({ ...data, loading: false })
          console.log('error ==>', error)
        })
    } catch (error: any) {
      enqueueSnackbar('Hubo un error al cargar las imagenes intente nuevamente', { variant: 'error' })
      setData({ ...data, loading: false })
    }
  }

  const loadData = () => {
    setData({ ...data, loading: true })
    webApiService.getIAEvaluation(Number(id)).then(res => {
      setData({ ...data, loading: true, result: res.data.result, cat: res.data.result.categoria })
    })
      .catch((error) => {
        setData({ ...data, loading: false })
        console.log('Error loading data:', error)
      })
  }

  useEffect(() => {
    if (ctx.tradein.grade_IA !== null) loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, ctx.tradein.grade_IA])

  if (ctx.tradein.id_status === 1) {
    return <div />
  }

  return (
    <div className='bg-white rounded-lg shadow-lg p-4 h-full'>
      <div className='grid grid-cols-2 border-b-1 mb-2 '>
        <div><h6 className='font-bold text-xl pb-2'>Evaluación estética</h6></div>
        {data.result !== null ? <div className='text-end font-black text-lg' hidden={data.result.newDiscountAmount === undefined}>Monto a descontar: <span className='text-primary'>{currencyFormat(Number(data.result.newDiscountAmount), import.meta.env.VITE_COUNTRY)}</span></div> : null}
      </div>
      <div className={(data.cat !== '' || ctx.tradein.grade_IA !== null) ? 'hidden' : 'flex p-2'}>
        <p className='mb-3 w-1/2'>Para iniciar la evaluación estética es necesario cargar todas las imágenes que se solicitan a continuación:</p>
        <div className='text-end w-1/2' hidden={images.filter(img => img === null).length > 0}><Button color='secondary' onClick={consultaAI} isLoading={data.loading}>Analizar</Button></div>
      </div>
      <div className='py-2 text-2xl font-bold' hidden={!data.loading || data.cat !== ''}><GradientText>Analizando los datos</GradientText></div>
      <div className='py-2' hidden={data.result === null}>
        <NUIAlert type={data.cat === 'A' ? 'success' : data.cat === 'B' || data.cat === 'C' ? 'warning' : data.cat === 'D' ? 'error' : 'error'}>
          {data.result !== null ? <p>Imagen frontal: {data.result.comentario_img_1}</p> : null}
          {data.result !== null ? <p>Imagen trasera: {data.result.comentario_img_2}</p> : null}
          {data.result !== null ? <p>Imagen lateral derecha: {data.result.comentario_img_3}</p> : null}
          {data.result !== null ? <p>Imagen inferior: {data.result.comentario_img_4}</p> : null}
          {data.result !== null ? <p>Imagen superior: {data.result.comentario_img_5}</p> : null}
          {data.result !== null ? <p>Imagen lateral izquierda: {data.result.comentario_img_6}</p> : null}
        </NUIAlert>
      </div>
      <div className={data.loading || data.cat !== '' || ctx.tradein.grade_IA !== null ? 'hidden' : 'grid grid-cols-6 gap-4'}>
        {['Imagen frontal', 'Imagen trasera', 'Imagen lateral derecha', 'Imagen inferior', 'Imagen superior', 'Imagen lateral izquierda'].map((label, index) => (
          <div
            key={index} className={images[index] === null ? 'col-span-3 md:col-span-1 flex items-end justify-center aspect-[10/16] relative border-2 border-dashed border-blue-400 bg-cover bg-center before:bg-opacity-50 before:bg-white before:absolute before:h-full before:w-full' : 'col-span-3 md:col-span-1 flex items-end justify-center aspect-[10/16] relative border-2 border-dashed border-blue-400 bg-cover bg-center'}
            style={{ backgroundImage: `url(${images[index] ? URL.createObjectURL(images[index]!) : defaultImages[index]})` }}
          >
            {images[index] && (
              <Button
                className='absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-700'
                onClick={() => handleRemoveImage(index)}
                isIconOnly
              >
                <MdClose />
              </Button>
            )}
            <input type='file' accept='image/*' className='hidden' id={`file-input-${index}`} onChange={(e) => handleFileChange(e, index)} />
            <label htmlFor={`file-input-${index}`} className='mb-5' hidden={images[index] !== null}>
              <Button size='sm' color='warning' as='span'>{images[index] ? 'Reemplazar' : `Cargar ${label}`}</Button>
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

export default IAEvaluation
